import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SharedModule } from '../../shared/shared.module';
import { UserListComponent } from './components/list/user-list.component';
import { UserModalComponent } from './components/user-modal/user-modal.component';
import { UsersService } from './service/users.service';
import { UserRoutingModule } from './user-routing.module';

@NgModule({
  imports: [CommonModule, SharedModule, InputsModule, UserRoutingModule],
  providers: [UsersService],
  declarations: [UserListComponent, UserModalComponent],
  exports: [UserListComponent],
  entryComponents: [UserModalComponent]
})
export class UserModule {}
